import type { ThemeClasses } from "../types";
import type { TFunction } from "i18next";
import type { Brand } from "../../../../../../store/reseller-admin/brandsStore";

interface BrandModelProps {
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  t: TFunction<"translation", undefined>;
  selectedBrand: Brand;
}

export default function BrandModel({ isDarkMode, themeClasses, t, selectedBrand }: BrandModelProps) {

  return (
    <div className={`mt-4 p-4 rounded-lg border ${isDarkMode ? "bg-dark-card border-gray-700" : "bg-blue-50 border-blue-200"}`}>
      <h4 className={`text-sm font-semibold mb-3 ${themeClasses.text}`}>
        {t("devices.sections.selectedBrandInfo")}
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.brandName")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.brand}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.model")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.model}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.protocol")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.network?.protocol || "-"}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.ipAddress")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.network?.ip_address || "-"}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.port")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.network?.port || "-"}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.operationalAlias")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.operational_alias || "-"}</p>
        </div>
        <div>
          <p className={`text-xs ${themeClasses.textSecondary}`}>{t("devices.fields.origin")}</p>
          <p className={`text-sm font-medium ${themeClasses.text}`}>{selectedBrand.origin || "-"}</p>
        </div>
      </div>
    </div>
  )
}
